<template>
    <UserTabs
        :selected-user="selectedUser"
        :personal-team="userPersonalTeam"
        tab-key="feature-management"
    >
        <div class="mt-12 rounded-md bg-white p-6 text-gray-900 shadow-md">
            <div class="grid grid-cols-4">
                <div
                    class="flex flex-col flex-wrap gap-2 sm:flex-row sm:items-center sm:justify-between"
                >
                    <AtomicButton
                        v-if="!props.selectedUser.email_verified_at"
                        size="sm"
                        color="yellow"
                        @click="setEmailVerifiedAt()"
                    >
                        <template #icon>
                            <InboxIcon class="mr-2 h-6 w-6" />
                        </template>

                        <div>
                            {{ t("vue.verify_user_email") }}
                        </div>
                    </AtomicButton>

                    <p v-if="props.selectedUser.email_verified_at">
                        email verified
                    </p>
                </div>
            </div>
        </div>
    </UserTabs>
</template>

<script lang="ts" setup>
import type IUser from "@/types/Members/IUser";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { ref, watch } from "vue";
import { useTranslations } from "@/composables/useTranslations.ts";
import { InboxIcon } from "@heroicons/vue/24/outline";

const { t } = useTranslations();

const props = defineProps<{
    selectedUser: IUser;
    personalTeam: ICurrentTeam;
    userPersonalTeam: ICurrentTeam;
}>();

const setEmailVerifiedAt = () => {
    if (props.selectedUser.email_verified_at) return;

    router.put(
        route("kiosk.users.feature-management.update", {
            user: props.selectedUser.id,
        }),
        { verifyUserEmail: true },
        { preserveScroll: true },
    );
};
</script>
